

import { createRoot } from 'react-dom/client';
import { SevenApp } from './SevenApp';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/styles.scss';

const queryClient = new QueryClient();
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);





root.render(
    <QueryClientProvider client={queryClient}>
      <SevenApp />
    </QueryClientProvider>
);






